var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0509 6.02998L2.5084 5.45831C2.21673 5.16664 1.9834 4.64164 1.9834 4.29164V2.94998C1.9834 2.24998 2.5084 1.72498 3.15006 1.72498H5.54173H7.86343H8.38403H10.8501C11.4918 1.72498 12.0168 2.24998 12.0168 2.89164V4.17498C12.0168 4.64164 11.7251 5.22498 11.4334 5.51664L8.9251 7.73331C8.5751 8.02498 8.34176 8.60831 8.34176 9.07498V11.5833C8.34176 11.9333 8.10843 12.4 7.81676 12.575L7.0001 13.1C6.24176 13.5666 5.19176 13.0416 5.19176 12.1083V9.01664C5.19176 8.60831 4.95843 8.08331 4.7251 7.79164L4.45093 7.50581C4.40355 7.45538 4.36619 7.39814 4.33946 7.33703L3.0509 6.02998Z",
    fill: "#6C738A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "b848b278c9b7a7b0725c61c6a0103ab9.svg";
export { ForwardRef as ReactComponent };